<template>
    <div class="text-center">
        <h2 class="p-b-20">绑定平台账号</h2>
        <Form ref="formBindUser" :model="formBindUserValidate" :rules="ruleBindUserValidate" :label-width="80">
            <FormItem label="F码" prop="fcode">
                <i-input v-model="formBindUserValidate.fcode" placeholder="请输入平台提供的F码"></i-input>
                <Alert type="error" show-icon v-show="pageView.showMessage">{{pageView.message}}</Alert>
            </FormItem>
            <FormItem label="">
                <Checkbox v-model="isChecked">我同意《平台使用协议》，并且允许接收企业微信通知消息</Checkbox>
            </FormItem>
            <FormItem>
                <Button type="error" long size="large" @click="handleSubmit('formBindUser')">绑定并登录</Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
const CryptoJS = require('crypto-js')

export default {
  name: 'binduser',
  props: {
    wxUid: String,
    appid: String
  },
  data () {
    return {
      pageView: {
        showMessage: false,
        message: ''
      },
      formBindUserValidate: {
        cropId: '',
        fcode: '',
        UserId: this.wxUid
      },
      ruleBindUserValidate: {
        fcode: [
          { required: true, message: '请输入F码', trigger: 'blur' }
        ]
      },
      isChecked: true
    }
  },
  methods: {
    handleSubmit (name) {
      if (!this.isChecked) {
        this.pageView.showMessage = true
        this.pageView.message = '请同意平台协议'
        return
      } else {
        this.pageView.showMessage = false
        this.formBindUserValidate.cropId = this.appid
      }

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.formBindUserValidate.UserId = this.wxUid
          // 开始绑定code和账号密码， 如果成功自动登录
          this.$store.dispatch('BindAndLogin', this.formBindUserValidate).then((data) => {
            this.pageView.showMessage = false
            const privateKey = data.privateKey
            const urlLoader = data.url
            // 加密登录信息,直接传输UserId
            const token = {
              Uid: this.wxUid,
              AppId: this.appid,
              website: process.env.WEBSIT
            }

            const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(token), privateKey).toString()
            window.location.href = urlLoader + '?token=' + encodeURIComponent(ciphertext)
          }).catch((error) => {
            this.pageView.showMessage = true
            this.pageView.message = error
          })
        }
      })
    }
  }
}
</script>
